import { useEffect, useState } from 'react'

import {
  Accordion,
  AccordionButton,
  AccordionItem,
  Box,
} from '@chakra-ui/react'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import _ from 'lodash'

import Icon from 'src/components/widgets/Icon/Icon'
import Loader from 'src/components/widgets/Loader/Loader'
import { toast } from 'src/components/widgets/Toaster'
import { BrandColor } from 'src/types'

import { Statistics } from '../getItListItemsCountByType'
import { InsideItemProps, InsideItems } from '../Inside'

const WAIT_ON_BUY_MS = 1000

const Item: React.FC<{
  itemDefinition: InsideItemProps
  count: number
  label: string
  brandColor: BrandColor
  isPreview: boolean
  onClick(): unknown
}> = ({ itemDefinition, count, label, brandColor, onClick, isPreview }) => {
  const [clicked, setClicked] = useState(false)
  const itemLabel = count === 1 ? itemDefinition.label : itemDefinition.plural

  useEffect(() => {
    if (clicked)
      setTimeout(() => {
        onClick()
      }, WAIT_ON_BUY_MS)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clicked])

  return (
    <AccordionItem
      key={label}
      mb={3}
      borderRadius={16}
      boxShadow="sm"
      borderColor="vapor"
      data-testid={`inside-item-${label}`}
      onClick={() => {
        if (isPreview) {
          toast('info', 'Purchase action not available in preview')
        } else {
          setClicked(true)
        }
      }}
    >
      <AccordionButton p={3} pr={5} _hover={{ bg: 'transparent' }}>
        <Box>{itemDefinition.icon}</Box>
        <Box flex="1" mx={6} textAlign="left">
          {!clicked && (
            <>
              <Box as="h5" className="thick" display="inline">
                {count}
              </Box>
              <Box display="inline" ml="2" className="body-small">
                {itemLabel}
              </Box>
            </>
          )}
          {!!clicked && (
            <Box
              display="inline"
              ml="2"
              className="body-small"
              color="graphite"
            >
              Unlocking this item...
            </Box>
          )}
        </Box>
        {clicked ? (
          <Loader color={brandColor} inline={true} />
        ) : (
          <Icon icon={faChevronRight} color="graphite" />
        )}
      </AccordionButton>
    </AccordionItem>
  )
}

const FreeItListInside: React.FC<{
  currentInside: Statistics
  uiData: InsideItems
  brandColor: BrandColor
  onClick(): unknown
  isPreview: boolean
}> = ({ currentInside, uiData, brandColor, onClick, isPreview }) => {
  return (
    <Accordion allowToggle>
      {currentInside
        .filter(({ count }) => count > 0)
        .map(({ label, count }, i) => {
          const itemDefinition: InsideItemProps = uiData[label]
          return (
            <Item
              key={i}
              itemDefinition={itemDefinition}
              count={count}
              label={label}
              brandColor={brandColor}
              onClick={onClick}
              isPreview={isPreview}
            />
          )
        })}
    </Accordion>
  )
}

export default FreeItListInside
